import React, { useState } from 'react';
import { supabase } from '../../lib/supabaseClient';

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cleanEmail = email.trim().toLowerCase();
    if (!cleanEmail) return;

    setLoading(true);
    setErrorMsg('');
    try {
      if (!supabase) {
        throw new Error('Supabase client is not initialized');
      }
      const { error } = await supabase.auth.resetPasswordForEmail(cleanEmail, {
        redirectTo: window.location.origin
      });

      if (error) {
        setErrorMsg(error.message || 'เกิดข้อผิดพลาดในการส่งลิงก์');
      } else {
        setSuccess(true);
      }
    } catch (err) {
      console.error('Forgot password exception:', err);
      setErrorMsg(err.message || 'เกิดข้อผิดพลาด');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setSuccess(false);
    setErrorMsg('');
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(15, 23, 42, 0.65)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '20px'
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          borderRadius: '20px',
          padding: '26px',
          maxWidth: '420px',
          width: '100%',
          boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
          textAlign: 'left'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
          <h3 style={{ margin: 0, color: '#1e293b', fontSize: '1.25em', fontWeight: 'bold' }}>
            🔑 ลืมรหัสผ่าน
          </h3>
          <button
            type="button"
            onClick={handleClose}
            aria-label="close-forgot-modal"
            style={{
              background: 'none',
              border: 'none',
              color: '#94a3b8',
              fontSize: '20px',
              cursor: 'pointer',
              padding: '4px'
            }}
          >
            ✕
          </button>
        </div>

        {success ? (
          <div>
            <div
              style={{
                padding: '14px',
                backgroundColor: '#f0fdf4',
                border: '1px solid #bbf7d0',
                borderRadius: '12px',
                color: '#166534',
                fontSize: '0.88em',
                lineHeight: 1.5,
                marginBottom: '16px'
              }}
            >
              ✅ <strong>ส่งลิงก์รีเซ็ตรหัสผ่านสำเร็จ!</strong>
              <br />
              ระบบได้ส่งลิงก์สำหรับรีเซ็ตรหัสผ่านไปยังอีเมล <strong>{email}</strong> ผ่านระบบของ{' '}
              <code>auth@fangdent.com</code> เรียบร้อยแล้ว กรุณาตรวจสอบกล่องข้อความหรือกล่องขยะ (Junk/Spam)
            </div>
            <button
              type="button"
              onClick={handleClose}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#6366f1',
                color: '#fff',
                border: 'none',
                borderRadius: '10px',
                fontSize: '0.95em',
                fontWeight: 'bold',
                cursor: 'pointer'
              }}
            >
              ปิดหน้าต่างนี้
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ margin: '0 0 14px 0', fontSize: '0.88em', color: '#64748b', lineHeight: 1.45 }}>
              กรุณากรอกอีเมลของเจ้าหน้าที่ ระบบจะส่งลิงก์สำหรับตั้งรหัสผ่านใหม่ไปยังอีเมลของคุณผ่าน{' '}
              <strong>auth@fangdent.com</strong>
            </p>

            {errorMsg && (
              <div
                style={{
                  padding: '10px',
                  backgroundColor: '#fef2f2',
                  border: '1px solid #fecaca',
                  borderRadius: '10px',
                  color: '#b91c1c',
                  fontSize: '0.85em',
                  marginBottom: '14px'
                }}
              >
                ⚠️ {errorMsg}
              </div>
            )}

            <div style={{ marginBottom: '16px' }}>
              <label
                style={{
                  display: 'block',
                  fontSize: '0.85em',
                  color: '#475569',
                  marginBottom: '6px',
                  fontWeight: '500'
                }}
              >
                อีเมลเจ้าหน้าที่
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="เช่น name@hospital.com หรือ email@gmail.com"
                required
                style={{
                  width: '100%',
                  padding: '12px 14px',
                  borderRadius: '10px',
                  border: '1.5px solid #cbd5e1',
                  fontSize: '0.95em',
                  boxSizing: 'border-box',
                  outline: 'none'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={handleClose}
                style={{
                  padding: '10px 18px',
                  backgroundColor: '#f1f5f9',
                  color: '#475569',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '0.9em',
                  cursor: 'pointer',
                  fontWeight: '500'
                }}
              >
                ยกเลิก
              </button>
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  backgroundColor: loading ? '#94a3b8' : '#6366f1',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '0.9em',
                  fontWeight: 'bold',
                  cursor: loading ? 'wait' : 'pointer',
                  boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)'
                }}
              >
                {loading ? 'กำลังส่ง...' : 'ส่งลิงก์รีเซ็ตรหัสผ่าน'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
